import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../AppContext";

function JobOrderFertigation({job}) {
  const {lang} = useContext(AppContext);
  if(!job) {
    return null
  }
  return (
    <Grid item xs={12}>
      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>{lang.fertigation_type}</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>{job.fertigation_type_name || ' - '}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{lang.fertigation_product}</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>{job.fertigation_product || ' - '}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  )
}

export default JobOrderFertigation;